import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
import { defineComponent, onMounted, ref } from 'vue';
import { getDicts } from '@/service/proRequisition/index';
export default defineComponent({
  name: 'CollectionItemTypePopup',
  components: {},
  emits: ['confirm-type'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var show = ref(false);
    //出库类型
    var type = ref([{
      text: '',
      value: 2
    }]);
    var openPopup = function openPopup() {
      show.value = true;
    };
    var onConfirm = function onConfirm(e) {
      show.value = false;
      emit('confirm-type', e);
    };
    var onCancel = function onCancel() {
      show.value = false;
    };
    var getDictsAsync = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              type.value.splice(0);
              _context.next = 3;
              return getDicts();
            case 3:
              res = _context.sent;
              type.value = res.data.map(function (item) {
                return {
                  text: item.title,
                  value: Number(item.value)
                };
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getDictsAsync() {
        return _ref2.apply(this, arguments);
      };
    }();
    onMounted(function () {
      getDictsAsync();
    });
    return {
      show: show,
      type: type,
      openPopup: openPopup,
      onConfirm: onConfirm,
      onCancel: onCancel
    };
  }
});